import { render } from "./ValidateAddressModal.vue?vue&type=template&id=a77eb572&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./ValidateAddressModal.vue?vue&type=script&lang=js"
export * from "./ValidateAddressModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__